<template>
  <div class="container">
    <div class="topHeader">
      <div class="bannerTit">
        <span>资讯信息</span>
      </div>
    </div>

    <div class="content" @click="handleClick">
      <div class="newsBox">
        <div class="leftTime">2025.10.16</div>
        <div class="centerContent">
          <div class="newsTitle">京东新车定价披露！有望采取“巧克力换电”模式</div>
          <div class="newsInfo">
            <p>
              10月15日，据澎湃新闻消息，这款由京东汽车宣布联合宁德时代旗下的时代电服和广汽集团共同推出的新车，根据披露的定位和车辆配置，预估定价在10万元-12万元之间。</p>
            <p>
              按规划，该车将于京东双十一期间正式发布，并由京东进行独家销售，在车型方面，有望将采取“巧克力换电”模式，预计为广汽埃安换电车型。</p>
          </div>
        </div>
        <div class="rightPic rightPic1"></div>
      </div>
      <div class="newsBox">
        <div class="leftTime">2025.10.14</div>
        <div class="centerContent">
          <div class="newsTitle">宁德时代传来五大消息！</div>
          <div class="newsInfo">
            <p>
              2025年10月13日，东风商用车与宁德时代在福建宁德举行战略合作签约仪式，基于过往成功的合作经验及未来愿景，双方正式确立新一轮五年长期战略合作，将在商用车电动化领域围绕前沿技术开发和应用、海外市场拓展、后市场发展以及行业生态共建等方面强强联合，互利共赢。</p>
            <p>双方将围绕产品研发、行业标准、行业生态共建等三大方面展开深度合作。</p>
          </div>
        </div>
        <div class="rightPic rightPic2"></div>
      </div>
      <div class="newsBox">
        <div class="leftTime">2025.10.11</div>
        <div class="centerContent">
          <div class="newsTitle">锂电池出口下月管制，新规落地！</div>
          <div class="newsInfo">
            <p>
              鉴于中国在全球锂电池产业链中占据主导地位，此次管制的出台，标志着中国在其具有显著产业优势的新能源关键材料领域，进一步深化和完善了贸易管制体系，必将对全球高端电池供应链的布局产生深远影响。</p>
            <p>
              根据公告内容，此次出口管制的范围精准覆盖了锂电池产业链的核心环节。在电池成品方面，管制对象聚焦于能量密度大于等于300Wh/kg的高性能可充放电锂离子电池单体与电池组。同时，其上游的制造设备，如卷绕机、叠片机、注液机、化成分容系统等，也被纳入管制清单。</p>
          </div>
        </div>
        <div class="rightPic rightPic3"></div>
      </div>
      <div class="newsBox">
        <div class="leftTime">2025.10.10</div>
        <div class="centerContent">
          <div class="newsTitle">三部门联合发文！明确2026—2027年新能源汽车减免购置税技术门槛</div>
          <div class="newsInfo">
            <p>
              近日，工信部等三部门联合发布2025年第24号公告，对2026—2027年减免车辆购置税新能源汽车产品技术要求进行调整，明确了纯电动乘用车、插电式（含增程式）混合动力乘用车的技术标准变化。</p>
            <p>
              根据公告内容，2026年1月1日起，凡是列入《减免车辆购置税的新能源汽车车型目录》（以下简称《减免税目录》）的车型，必须严格符合本公告所规定的技术要求，这意味着不符合新要求的车型将无法享受购置税减免优惠。</p>
          </div>
        </div>
        <div class="rightPic rightPic4"></div>
      </div>
      <div class="newsBox">
        <div class="leftTime">2025.10.09</div>
        <div class="centerContent">
          <div class="newsTitle">重磅！我国固态电池领域取得重大突破，新华社连发报道</div>
          <div class="newsInfo">
            <p>
              近日，新华社接连发布两则重磅报道，显示我国科研人员在全固态锂电池关键界面技术领域取得重要突破，为这一被誉为“下一代储能技术”的核心方向迈向实用化提供了坚实支撑。</p>
            <p>
              来自中国科学院物理研究所的黄学杰团队联合华中科技大学、中科院宁波材料技术与工程研究所等单位，开发出一种阴离子调控技术，成功解决了全固态金属锂电池中电解质与锂电极之间难以紧密接触的世界性难题。</p>
          </div>
        </div>
        <div class="rightPic rightPic5"></div>
      </div>
    </div>
    <!--    弹框显示二维码区域-->
    <div class="mask" v-show="maskShow">
      <div class="maskContent">
        <div class="close" @click="handleClose">×</div>
        <div class="pic"></div>
        <p>行业资讯为付费内容，扫码了解更多</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news",
  data() {
    return {
      maskShow:false
    };
  },
  mounted() {
  },
  methods: {
    handleClick() {
      this.maskShow = true
    },
    handleClose(){
      this.maskShow = false
    }
  },
  computed: {},
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  min-height: 70vh;
  padding-bottom: 50px;

  .topHeader {
    width: 100%;
    height: 200px; /* 让高度自适应，以保持图片的原始纵横比 */
    background: url("../../assets/images/bidProject/jpHeader.png") center/cover
    no-repeat; /* 替换为你的背景图路径 */

    .bannerTit {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      font-weight: 600;
      font-size: 28px;
      color: #ffffff;
      position: relative;

      span {
        position: absolute;
        bottom: 36px;
      }
    }
  }

  .content {
    width: 1200px;
    margin: 0 auto;
    line-height: 3em;
    padding-top: 40px;
    font-size: 14px;

    .newsBox {
      height: 240px;
      padding: 20px 0;
      border-bottom: 1px solid #e5e5e5;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
    }

    .leftTime {
      width: 180px;
      font-size: 26px;
      color: #333333;
      vertical-align: top;
    }

    .centerContent {
      width: 800px;
      display: flex;
      flex-direction: column;

      .newsTitle {
        font-size: 18px;
        color: #333333;
        margin-bottom: 32px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .newsInfo {
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        display: inline-block;
        overflow: hidden;

        p {
          margin-bottom: 12px;
        }
      }
    }

    .rightPic {
      width: 200px;
      height: 200px;
    }

    .rightPic1 {
      background: url("../../assets/images/news/1.png") no-repeat center center;
      background-size: 100%;
    }

    .rightPic2 {
      background: url("../../assets/images/news/2.png") no-repeat center center;
      background-size: 100%;
    }

    .rightPic3 {
      background: url("../../assets/images/news/3.png") no-repeat center center;
      background-size: 100%;
    }

    .rightPic4 {
      background: url("../../assets/images/news/4.png") no-repeat center center;
      background-size: 100%;
    }

    .rightPic5 {
      background: url("../../assets/images/news/5.png") no-repeat center center;
      background-size: 100%;
    }
  }
  .mask{
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .6);
    .maskContent{
      width: 300px;
      height: 300px;
      background-color: #fff;
      text-align: center;
      margin:30vh auto;
      border-radius: 10px;
      padding-top: 30px;
      box-sizing: border-box;
      position: relative;
      .close{
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 20px;
        cursor: pointer;
        color: #666666;
      }
      .pic{
        width: 200px;
        height: 200px;
        margin:0 50px 30px;
        background: url("../../assets/images/news/6.png") no-repeat center center;
        background-size: 100% 100%;
      }
      p{
        font-size: 14px;
        color: #666666;
      }
    }
  }
}
</style>
